export default function PhoneNumber (n: string): string {
  return n.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3')
}
